/* istanbul ignore file */

import { useEffect } from 'react';

/* The usage of CDN is for pilot for a customer and would be removed in upcoming diffs and in long term we will go with lexical.dev */

const QUILL_CDN_LINK_URL = ['https://cdnjs.cloudflare.com/ajax/libs/quill/2.0.0-rc.2/quill.snow.min.css', 'https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.9.0/styles/atom-one-dark.min.css'];

// Katex required in both the editor as we added katex support in both editor
const KATEX_LINK_URL = ['https://cdn.jsdelivr.net/npm/katex@0.16.10/dist/katex.min.css'];
export const useLoadStyles = (forLexical = false) => {
  useEffect(() => {
    const cleanUp = Array<HTMLLinkElement>();
    (forLexical ? KATEX_LINK_URL : [...KATEX_LINK_URL, ...QUILL_CDN_LINK_URL]).forEach(URL => {
      // Check if the style sheet with the given URL already exists
      const existingLink = document.querySelector(`link[href="${URL}"]`);
      if (!existingLink) {
        // If the style sheet doesn't exist, create a new link element
        const link = document.createElement('link');
        link.href = URL;
        link.rel = 'stylesheet';
        link.type = 'text/css';

        // Append the link element to the head of the document
        document.head.appendChild(link);
        cleanUp.push(link);
      }
    });
    // Cleanup function to remove the link element when the component unmounts
    return () => {
      cleanUp.forEach(link => {
        document.head.removeChild(link);
      });
    };
  }, [forLexical]); // useEffect dependency on the url
};